import { ErreurPaiement, StatutReglement } from "../../services/paiement";

/**
 * Formatage monétaire de référence pour les paiements. Il n'existait aucun utilitaire de ce type
 * dans l'application, chaque écran faisant son propre `${valeur} €`.
 */
export const formatMontant = (montant?: number | null): string => {
    if (montant === undefined || montant === null || Number.isNaN(montant)) {
        return "—";
    }
    return `${montant.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
};

/**
 * Reproduit la règle du back (StatutReglementEnum.of) : TROP_PERCU est testé avant SOLDE, et un
 * montant dû nul est considéré comme soldé.
 *
 * Les deux montants viennent de la vue `v_inscription_light`, qui les expose séparément plutôt que
 * de matérialiser l'état — celui-ci se déduit sans ambiguïté.
 */
export const getStatutReglement = (montantTotal?: number | null, montantRegle?: number | null): StatutReglement => {
    const total = montantTotal ?? 0;
    const regle = montantRegle ?? 0;
    if (regle > total) {
        return StatutReglement.TROP_PERCU;
    }
    if (regle === total) {
        return StatutReglement.SOLDE;
    }
    return regle === 0 ? StatutReglement.NON_REGLE : StatutReglement.PARTIEL;
};

export const getResteAPayer = (montantTotal?: number | null, montantRegle?: number | null): number =>
    (montantTotal ?? 0) - (montantRegle ?? 0);

const LIBELLES_ERREUR: Record<string, string> = {
    [ErreurPaiement.CIBLE_INTROUVABLE]: "L'inscription concernée est introuvable.",
    [ErreurPaiement.MONTANT_INVALIDE]: "Le montant doit être strictement positif.",
    [ErreurPaiement.MONTANT_SUPERIEUR_RESTE]: "Le montant saisi dépasse le reste à payer.",
    [ErreurPaiement.DATE_OBLIGATOIRE]: "La date du paiement est obligatoire.",
    [ErreurPaiement.DATE_FUTURE]: "La date du paiement ne peut pas être postérieure à aujourd'hui.",
    [ErreurPaiement.MODE_OBLIGATOIRE]: "Le mode de paiement est obligatoire.",
    [ErreurPaiement.MODE_WEB_NON_AUTORISE]: "Le paiement en ligne ne peut pas être saisi manuellement.",
    [ErreurPaiement.PAIEMENT_ANNULE_NON_MODIFIABLE]: "Ce paiement est annulé : il ne peut plus être modifié.",
};

export const getLibelleErreurPaiement = (code?: string): string =>
    (code && LIBELLES_ERREUR[code]) || "Le paiement n'a pas pu être enregistré.";
